module.exports = __webpack_public_path__ + "img/progress_091.febe08d8.png";